//
//
//
//
//
//
//
//
//
export default {
  name: 'SvcManage',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created SvcManage');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated SvcManage');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};